import React from 'react';
import CustomPaper from "../../../shared/utils/CustomPaper";
import PDFIcon from 'material-ui/svg-icons/image/picture-as-pdf';
import AuthService from '../../../../services/AuthService';
import ReactTable from "react-table";
import moment from '../../../shared/utils/moment_fr';
import reactTableProps from '../../../shared/utils/reactTableProps';
import {connect} from "react-redux";
import pdfHandler from "../../../shared/utils/pdfHandler";


class ConsulterEntretien extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            entretiens:[]
        };
        this.Auth = new AuthService();
        this.downloadFile = this.downloadFile.bind(this);
    }


    componentDidMount(){
        this.Auth.fetch('/societe/signed_entretiens')
            .then(resp => this.setState({entretiens:resp.data.payload}))
    }

    downloadFile(id){
       this.Auth.fetch("/services/pdf/entretien/"+id, {responseType: 'arraybuffer'})
           .then(resp=>pdfHandler(resp.data, 'entretien_professionnel.pdf'));
    }


    render() {
        return (
            <CustomPaper title="Consulter un entretien">
                <ReactTable

                    filterable
                    defaultFilterMethod={(filter, row) => {
                        let row_value = row[filter.id].toUpperCase();
                        let filter_value = filter.value.toUpperCase();
                        return (row_value.indexOf(filter_value) > -1);
                    }
                    }
                    {...reactTableProps}
                    data={this.state.entretiens}
                    columns=
                        {
                            [
                                {
                                    Header: "Salarié",
                                    columns: [
                                        {
                                            Header: "Numéro",
                                            accessor: "num_salarie",
                                            maxWidth:150
                                        },
                                        {
                                            Header: "Nom",
                                            accessor: "nom",
                                            maxWidth:150
                                        },
                                        {
                                            Header: "Prénom",
                                            accessor: "prenom",
                                            maxWidth:150
                                        },
                                    ]
                                },{
                                    Header: "Entretien",
                                    columns: [
                                        {
                                            Header: "Type",
                                            accessor: "type",
                                            Filter: ({ filter, onChange }) =>
                                                <select
                                                    onChange={event => onChange(event.target.value)}
                                                    style={{ width: "100%" }}
                                                    value={filter ? filter.value : ''}
                                                >
                                                    <option key={999} value='' >Tous les types</option>
                                                    {this.props.params_types_entretien.map(
                                                        e=> <option key={e.id} value={e.type}>{e.type}</option>
                                                    )}
                                                </select>
                                        },
                                        {
                                            Header: "Date de signature",
                                            accessor: "date_signature",
                                            filterable:false,
                                            Cell: row => (
                                                <div>
                                                    {moment(row.value).format('llll')}
                                                </div>),
                                            maxWidth:200
                                        }
                                    ]
                                },
                                {
                                    Header: "Téléchargement",
                                    sortable:false,
                                    filterable:false,
                                    columns: [
                                        {
                                            filterable:false,
                                            sortable:false,
                                            accessor: "id",
                                            Cell: row => (
                                                <div
                                                    style={{cursor:'pointer', textAlign:'center'}}
                                                    onClick={()=>this.downloadFile(row.value)}>
                                                    Télécharger le fichier <PDFIcon/>
                                                </div>
                                            )
                                        }

                                    ]
                                }
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {
        params_types_entretien: store.params.types_entretien
    }
}

export default connect(mapStateToProps)(ConsulterEntretien);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/ConsulterEntretien.js